import { useState } from 'react';
import { WidgetProps } from '@rjsf/core';

const DisplayOption = (props: WidgetProps) => {
    const { schema, value, onChange } = props;
    const [isChecked, setChecked] = useState<string>(value || schema.default);

    const onChangeDisplay = (event: any) => {
        onChange(event.target.value);
        setChecked(event.target.value);
    };

    return (
        <div className="display-option">
            <label id="color-picker-label">{schema?.title}</label>
            <div className="display-options">
                <label className="container">
                    Inline
                    <input
                        type="radio"
                        value="inline"
                        name="inline"
                        checked={isChecked === 'inline'}
                        onChange={onChangeDisplay}
                    />
                    <span className="checkmark"></span>
                </label>
                <label className="container">
                    Block
                    <input
                        type="radio"
                        value="block"
                        name="block"
                        checked={isChecked === 'block'}
                        onChange={onChangeDisplay}
                    />
                    <span className="checkmark"></span>
                </label>
                <label className="container">
                    Inline-block
                    <input
                        type="radio"
                        value="inline-block"
                        name="inline-block"
                        checked={isChecked === 'inline-block'}
                        onChange={onChangeDisplay}
                    />
                    <span className="checkmark"></span>
                </label>
                <label className="container">
                    Flex
                    <input
                        type="radio"
                        value="flex"
                        name="flex"
                        checked={isChecked === 'flex'}
                        onChange={onChangeDisplay}
                    />
                    <span className="checkmark"></span>
                </label>
            </div>
        </div>
    );
};

export default DisplayOption;
